import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createVoiceGroup, getVoiceGroups, updateVoiceGroup, deleteVoiceGroup, updateVoice, uploadVoiceAvatar, uploadVoiceSample } from './async'

export interface IVoiceGroupVoice {
  voice_id: number
  technical_name: string
}

export interface IVoiceGroupUser {
  user_id: number
  username: string
}

export interface IVoiceGroup {
  voice_group_id: number
  name: string
  is_default: boolean
  is_system: boolean
  voices: IVoiceGroupVoice[]
  users: IVoiceGroupUser[]
  created_at: string
  updated_at: string
}

type TVoicesTab = 'voices' | 'groups'

interface IStateVoiceGroups {
  groups: IVoiceGroup[]
  loading: boolean
  activeTab: TVoicesTab
}

const initialState: IStateVoiceGroups = {
  groups: [],
  loading: false,
  activeTab: 'voices',
}

const voiceGroupsSlice = createSlice({
  name: 'voiceGroups',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<TVoicesTab>) => {
      state.activeTab = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVoiceGroups.pending, (state) => {
        state.loading = true
      })
      .addCase(getVoiceGroups.fulfilled, (state, action: PayloadAction<IVoiceGroup[]>) => {
        state.loading = false
        state.groups = action.payload
      })
      .addCase(getVoiceGroups.rejected, (state) => {
        state.loading = false
      })
      .addCase(createVoiceGroup.pending, (state) => {
        state.loading = true
      })
      .addCase(createVoiceGroup.fulfilled, (state, action: PayloadAction<{ response_code: number; voice_group_id: number; voice_groups: IVoiceGroup[] }>) => {
        state.loading = false
        if (action.payload?.response_code === 0 && action.payload.voice_groups) {
          state.groups = action.payload.voice_groups
        }
      })
      .addCase(createVoiceGroup.rejected, (state) => {
        state.loading = false
      })
      .addCase(updateVoiceGroup.pending, (state) => {
        state.loading = true
      })
      .addCase(updateVoiceGroup.fulfilled, (state, action: PayloadAction<{ response_code: number; voice_groups: IVoiceGroup[] }>) => {
        state.loading = false
        if (action.payload?.response_code === 0 && action.payload.voice_groups) {
          state.groups = action.payload.voice_groups
        }
      })
      .addCase(updateVoiceGroup.rejected, (state) => {
        state.loading = false
      })
      .addCase(deleteVoiceGroup.pending, (state) => {
        state.loading = true
      })
      .addCase(deleteVoiceGroup.fulfilled, (state, action: PayloadAction<{ response_code: number; voice_groups: IVoiceGroup[] }>) => {
        state.loading = false
        if (action.payload?.response_code === 0 && action.payload.voice_groups) {
          state.groups = action.payload.voice_groups
        }
      })
      .addCase(deleteVoiceGroup.rejected, (state) => {
        state.loading = false
      })
      .addCase(updateVoice.pending, (state) => {
        state.loading = true
      })
      .addCase(updateVoice.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(updateVoice.rejected, (state) => {
        state.loading = false
      })
      .addCase(uploadVoiceAvatar.pending, (state) => {
        state.loading = true
      })
      .addCase(uploadVoiceAvatar.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(uploadVoiceAvatar.rejected, (state) => {
        state.loading = false
      })
      .addCase(uploadVoiceSample.pending, (state) => {
        state.loading = true
      })
      .addCase(uploadVoiceSample.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(uploadVoiceSample.rejected, (state) => {
        state.loading = false
      })
  },
})

export const { setActiveTab } = voiceGroupsSlice.actions
export default voiceGroupsSlice.reducer
